'use client';

import * as React from 'react';
import { useSearchParams } from 'next/navigation';
import { Button, Stack } from '@mui/material';
import { toast } from 'sonner';

import { RowProps } from '@/types/general';
import { DynamicTable } from '@/components/core/reusable-table-v3';

import { getGamesSettingsTableData } from '../helpers/games-settings-table-data';
import { gamesSettingsTableHeaders } from '../helpers/games-settings-table-headers';

export function GameSettingsTable({ gameData }: { gameData: any }): React.JSX.Element | null {
  const [gameSettings, setGameSettings] = React.useState(gameData.settings);
  const [isLoading, setIsLoading] = React.useState(false);
  const tableData: RowProps[] = getGamesSettingsTableData({
    gameData: gameSettings,
    setGameData: setGameSettings,
  });

  const searchParams = useSearchParams();
  const opId = searchParams.get('opId');

  const handleSave = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const res = await fetch(`/api/games/settings?opId=${opId}&gameId=${gameData.gameId}`, {
        method: 'PUT',
        body: JSON.stringify(gameSettings),
      });
      const result = await res.json();
      if (res.ok && result.success) {
        toast.success('Game settings have been updated successfully!');
      } else {
        toast.error('Error:500 | Unable to update game settings!');
      }
    } catch (e) {
      //noob
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack>
      <DynamicTable headers={gamesSettingsTableHeaders} rows={tableData} />
      <Stack direction="row" justifyContent="end" gap={2}>
        <Button loading={isLoading} variant="contained" onClick={handleSave}>
          Save
        </Button>
      </Stack>
    </Stack>
  );
}
